import FullScreenLayout from '@/layouts/FullScreen';
import Home from '../views/Home/index';
import MobileHome from '../views/Home/Mobile';
import Login from '../views/Home/Loginv2';

export default [
    {
        path: '/index',
        component: FullScreenLayout,
        meta: {
            title: '首页'
        },
        children: [
            {
                path: '',
                name: 'home',
                meta: {
                    title: '欢迎',
                    allowNotLogin: false
                },
                component: Home
            },
            {
                path: '/user/:userid/index',
                name: 'home',
                meta: {
                    title: '欢迎'
                },
                component: Home
            },
            {
                path: '/mobile',
                name: 'homeMobile',
                meta: {
                    title: '欢迎',
                    allowNotLogin: true
                },
                component: MobileHome
            },
            {
                path: '/user/:userid/mobile',
                name: 'homeMobile',
                meta: {
                    title: '欢迎'
                },
                component: MobileHome
            }
        ]
    },
    {
        path: '/login',
        component: FullScreenLayout,
        meta: {
            title: '登录'
        },
        children: [
            {
                path: '',
                name: 'login',
                meta: {
                    title: '登录',
                    allowNotLogin: true
                },
                component: Login
            }
        ]
    },
    {
        path: '/',
        redirect: {
            name: 'home'
        }
    },
    {
        path: '/user/:userid',
        name: 'User',
        redirect: {
            path: '/user/:userid/index'
        }
    }
];